export default (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 9.99188C3 9.57767 3.33579 9.24188 3.75 9.24188H20.25C20.6642 9.24188 21 9.57767 21 9.99188C21 10.4061 20.6642 10.7419 20.25 10.7419H3.75C3.33579 10.7419 3 10.4061 3 9.99188Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 14.4919C3 14.0777 3.33579 13.7419 3.75 13.7419H20.25C20.6642 13.7419 21 14.0777 21 14.4919C21 14.9061 20.6642 15.2419 20.25 15.2419H3.75C3.33579 15.2419 3 14.9061 3 14.4919Z"
      fill="currentColor"
    />
  </>
);
